// extracted by mini-css-extract-plugin
export default {"formGroup":"TextDisplay_formGroup__SGhU4","textDisplay":"TextDisplay_textDisplay__vJSYf","textLabel":"TextDisplay_textLabel__GTORv"};